import React from "react";
import AddRouteForm from "../route/AddRouteForm";

const CreateNewRouteForm = (props) => {
  return <AddRouteForm {...props} />;
};

export default CreateNewRouteForm;
